import PropTypes from 'prop-types';

export const nullStatePropTypes = {
  cardTitle: PropTypes.string.isRequired,
  bodyText: PropTypes.string.isRequired,
  imageAlt: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  learnMoreText: PropTypes.string,
  componentId: PropTypes.string,
};
